import { LinearProgressOverlay } from '@campfire/linear-progress-overlay';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';
import { useVolunteerProfileActions } from '../../volunteer-profile-actions';

export const VolunteerCommonProfileReturnToApplicantDialog = ({
  open,
  onClose,
  handleSuccess,
  volunteerId,
  fullName,
}: {
  open: boolean;
  onClose: () => void;
  handleSuccess: () => void;
  volunteerId: string;
  fullName: string;
}) => {
  const { runReturnVolunteerToApplicant, runReturnVolunteerToApplicantLoading } = useVolunteerProfileActions();
  const { theme } = useCampfireTheme();

  return volunteerId ? (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='return-to-applicant-dialog-title'
      aria-describedby='return-to-applicant-dialog-description'
    >
      <DialogTitle id='return-to-applicant-dialog-title'>{`Return Volunteer to Applicant?`}</DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <Box paddingLeft={2} paddingRight={2}>
          <DialogContentText>{fullName}</DialogContentText>
          <DialogContentText id='return-to-applicant-dialog-description'>
            {`They will be removed from all teams and upcoming rosters, their current application will be archived, and they will return to the applicant task stage.`}
            <br />
            {`They can still sign in to see and update their tasks. Once their profile is complete they will rejoin as a volunteer with their history intact.`}
          </DialogContentText>
        </Box>
        <LinearProgressOverlay isLoading={runReturnVolunteerToApplicantLoading} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{`Cancel`}</Button>
        <Button
          onClick={() => runReturnVolunteerToApplicant({ volunteerId, handleSuccess })}
          autoFocus
          disabled={runReturnVolunteerToApplicantLoading}
          style={{
            color: theme.palette.error.main,
          }}
        >{`Return to Applicant`}</Button>
      </DialogActions>
    </Dialog>
  ) : null;
};
